// src/components/Header/Header.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about-us' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Admission', path: '/admission' },
    { name: 'Contact Us', path: '/contact-us' }
  ];

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      {/* <div className="header-top">
        <div className="container">
          <div className="header-top-content">
            <div className="contact-info">
              <span className="info-item">
                <i className="icon">📞</i> +91 98765 43210
              </span>
              <span className="info-item">
                <i className="icon">✉️</i> info@disneylandpreschool.com
              </span>
            </div>
            <div className="social-links">
              <a href="#facebook" className="social-link">f</a>
              <a href="#instagram" className="social-link">📷</a>
              <a href="#youtube" className="social-link">▶</a>
            </div>
          </div>
        </div>
      </div> */}
      
      <nav className="navbar">
        <div className="container">
          <div className="nav-content">
            <Link to="/" className="logo">
              <div className="logo-circle">
                <span className="logo-text">DisneyLand</span>
                <span className="logo-subtitle">Preschool</span>
              </div>
            </Link>

            <button className="menu-toggle" onClick={toggleMenu}>
              <span className={isMenuOpen ? 'active' : ''}></span>
              <span className={isMenuOpen ? 'active' : ''}></span>
              <span className={isMenuOpen ? 'active' : ''}></span>
            </button>

            <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link 
                    to={item.path} 
                    className={location.pathname === item.path ? 'active' : ''}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;